import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListRecruitmentRequirementStart,
  getListRecruitmentRequirementSuccess,
  getListRecruitmentRequirementFailed,
} from "../redux/getListRecruitmentRequirement";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { formSearchRecruitmentDataSelector } from "../redux/selector";
import { getRecruitmentRequirementApi } from "core/http/service/recruitment";
import { formatFromDate, formatToDate } from "helper/utils";

function* getListRecruitmentRequirementWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector("recruitmentRequirement")
  );
  const formFilter = yield select(formSearchRecruitmentDataSelector);

  const { from, to, ...restFormFilter } = formFilter;

  const params = {
    offset,
    limit,
    from: formatFromDate(from),
    to: formatToDate(to),
    ...restFormFilter,
  };

  try {
    const res = yield call(getRecruitmentRequirementApi, params);
    yield put({
      type: getListRecruitmentRequirementSuccess.type,
      payload: {
        data: res.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListRecruitmentRequirementFailed.type,
    });
  }
}

function* watchGetListRecruitmentRequirement() {
  yield takeLatest(
    getListRecruitmentRequirementStart.type,
    getListRecruitmentRequirementWork
  );
}

export default function* getListRecruitmentRequirementSaga() {
  yield all([watchGetListRecruitmentRequirement()]);
}
